<template>
  <div>
    <v-row>
       <v-col cols="4" class="mb-4">
        <h2 class="title" v-text="$t('exercise_travel.step1.title')"></h2>
      </v-col>
      <v-col cols="6" class="">
        <p
          v-for="(item, index) in $t('exercise_travel.step1.description')"
          :key="index"
          v-text="item"
        />
        <ol>
          <li
            v-for="(item, index) in $t('exercise_travel.step1.list')"
            :key="index"
            v-text="item"
          />
        </ol>
      </v-col>
    </v-row>
    <!-- Exercise column -->
    <v-col cols="12">
      <exercise-logic-multiple
        exCollection="travelExCollection"
        refCollection="travelCollection"
        @ready="onReady"
        @error="onError"
        @saved="onSaved"
        @savedNext="onSavedNext"
        @loadedEx="onLoadedEx"
        @loadedRef="onLoadedRef"
        @modifyEx="onModifyEx"
        :doc="doc"
        :shared="false"

      >
        <template slot-scope="{ saveExercise }">
          <v-stepper v-model="e1">
            <v-stepper-header>
              <template v-for="tab in tabs">
                <v-stepper-step
                  :key="`tab${tab.count}`"
                  color="amber"
                  :complete="e1 > tab.count"
                  :step="tab.count"
                  @click="el = tab.count"
                  >{{ tab.title }}</v-stepper-step
                >
                <v-divider :key="`divider${tab.count}`"></v-divider>
              </template>

              <v-stepper-step
                  color="amber"
                  :complete="e1 > 5"
                  step="5"
                  @click="el = 5"
                  >Results</v-stepper-step
                >
                <v-divider></v-divider>

            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content
                v-for="tab in tabs"
                :key="`tab${tab.count}`"
                :step="tab.count"
              >
                <v-row v-if="ready">
                  <v-col cols="6" v-if="tab.title != 'Results'">
                    <travel-site :item="ref"/>
                  </v-col>

                  <v-col cols="6">
                    <component
                      :is="tab.component"
                      v-model="doc[tab.model]"
                      :title="tab.title"
                      :label="tab.title"
                      :prefix="tab.prefix"
                      :color="tab.color"
                    />
                  </v-col>
                </v-row>

                <bottom-navigation
                  :save="tab.save"
                  :next="tab.next"
                  :prev="tab.prev"
                  :gridView="false"
                  :gridToggle="false"
                  @save="saveExercise"
                  @prev="prevStep"
                  @next="saveExercise(false)"
                >
                </bottom-navigation>

              </v-stepper-content>

               <v-stepper-content
                step="5"
              >
                <v-row v-if="ready">
                
                  <v-col cols="12">
                    <travel-results :doc="exercise" :uid="currentUser.uid" :pid="currentProjectModel.id">

                    </travel-results>
                  </v-col>
                </v-row>

                <bottom-navigation
                  :save="true"
                  :next="false"
                  :prev="true"
                  :gridView="false"
                  :gridToggle="false"
                  @save="saveExercise"
                  @prev="prevStep"
                  @next="saveExercise(true)"
                >
                </bottom-navigation>

              </v-stepper-content>



            </v-stepper-items>
          </v-stepper>
        </template>
      </exercise-logic-multiple>
    </v-col>

    <v-dialog v-model="dialog" max-width="800">
      <v-card v-if="dialogMode == 'save'">
        <v-card-title
          class="headline"
          v-text="$t('exercise_service.saved.title')"
        ></v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="closeDialog">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card v-if="dialogMode == 'add'">
        <v-card-title>Add note</v-card-title>

        <v-card-text>
          <travel-add @complete="closeDialog" />
        </v-card-text>
      </v-card>

      <v-card light v-if="dialogMode == 'show'">
        <v-card-text class="pa-10">
          <travel-show :id="cardId" @complete="closeDialog" />
        </v-card-text>
      </v-card>

      <v-card v-if="dialogMode == 'edit'">
        <v-card-title class="headline">Edit note</v-card-title>

        <v-card-text>
          <travel-edit :id="cardId" @complete="closeDialog" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { BottomNavigation } from "@/components/core";
import { ExerciseLogicMultiple } from "@/components/exercises";
import {
  TravelAdd,
  TravelCard,
  TravelEdit,
  TravelForm,
  TravelResults,
  TravelSite
} from "@/views/user/exercises/travel";

// const fb = require("@/firebaseConfig.js");

export default {
  name: "UserTravel",
  data() {
    return {
      e1: 1,
      exercise: null,
      dialog: false,
      dialogMode: "add",
      doc: {},
      ref: null,
      ready: false,
      tabs: [
        {
          title: "Core brand Italy",
          count: 1,
          component: TravelForm,
          model: "italy",
          flag: "italy",
          next: true,
          prev: true,
          save: false,
        },
        {
          title: "Australia",
          count: 2,
          component: TravelForm,
          model: "australia",
          flag: "australia",
          next: true,
          prev: true,
          save: false,
        },
        {
          title: "France",
          count: 3,
          component: TravelForm,
          model: "france",
          flag: "france",
          next: true,
          prev: true,
          save: false,
        },
        {
          title: "Everywhere",
          count: 4,
          component: TravelForm,
          model: "everywhere",
          flag: "everywhere",
          next: true,
          prev: true,
          save: false,
        }
      ],
      debug: false,
    };
  },
  components: {
    BottomNavigation,
    ExerciseLogicMultiple,
    TravelAdd,
    TravelCard,
    TravelEdit,
    TravelResults,
    TravelSite
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  mounted() {},
  methods: {
    nextStep() {
      this.e1++;
    },
    prevStep() {
      this.e1--;
    },
    onReady() {},
    onError() {
      console.log("error");
    },
    onSaved() {
      console.log("saved");
    },
    onLoadedRef(ref) {
      console.log("loaded ref", ref);
      this.ref = ref[0];
    },
    onLoadedEx(ex) {
      console.log("loaded exercises", ex);
      if (ex != null) {
        this.exercise = ex;
        console.log(ex)
        this.$set(this.doc, 'italy', ex.doc.italy);
        this.$set(this.doc, 'france', ex.doc.france);
        this.$set(this.doc, 'australia', ex.doc.australia);
        this.tabs.forEach((x) => {
          let model = `${x.model}`
          let content = {
            flag: x.flag,
            title: x.title,
            concept: ex.doc[model].concept,
            description: ex.doc[model].description,
            promise: ex.doc[model].promise,
            justification: ex.doc[model].justification,
            pillars: this.ref.pillars,
            index: x.count
          };
          this.$set(this.doc, [x.model], content);
        });
      } else {
        this.tabs.forEach((x) => {
          let content = {
            flag: x.flag,
            title: x.title,
            concept: this.ref.concept,
            description: this.ref.description,
            promise: this.ref.promise,
            justification: this.ref.justification,
            pillars: this.ref.pillars,
            index: x.count
          };
          this.$set(this.doc, [x.model], content);
        });
      }
      this.ready = true;
    },
    onModifyEx(items) {
      console.log("modify exercises", items);
      this.exercises = [...items];
    },
    onSavedNext() {
      this.nextStep();
    },
    addIdea() {
      this.dialogMode = "add";
      this.dialog = true;
    },
    editNote($event) {
      console.log("edit note", $event);
      this.dialogMode = "edit";
      this.cardId = $event;
      this.dialog = true;
    },
    showNote($event) {
      console.log("show note", $event);
      this.dialogMode = "show";
      this.cardId = $event;
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
      this.dialogMode = "";
    },
  },
};
</script>

<style lang="scss"></style>
